// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"7538":"recorder","9983":"profiler"}[chunkId] + "." + {"7538":"5ca163c663691800","9983":"ed180344ca87be3f"}[chunkId] + ".js";
};